import dagestanImg from '@/assets/site-dagestan.webp'
import astrakhanImg from '@/assets/site-astrakhan.webp'
import { absoluteUrl } from '@/lib/site'

export const PRODUCTION_SITES = [
  {
    id: 'dagestan',
    slug: 'dagestan',
    href: '/production/dagestan',
    title: 'УЗВ-комплекс в Дагестане',
    shortTitle: 'Республика Дагестан',
    loc: 'Кизлярский район',
    region: 'Республика Дагестан',
    locality: 'с. Краснооктябрьское',
    type: 'УЗВ-комплекс',
    image: dagestanImg,
    imageAlt: 'Производственный УЗВ-комплекс СК-АКВА в Дагестане',
    intro:
      'Основной производственный комплекс СК-АКВА в Республике Дагестан работает с технологиями замкнутого водоснабжения и обеспечивает выращивание осетровых пород в контролируемой среде.',
    points: [
      'Производственная мощность 70–80 тонн',
      '20 бассейнов для малька',
      '24 бассейна для ремонтных групп',
      '20 бассейнов для выращивания крупной рыбы',
      'Современные системы фильтрации и очистки',
    ],
    details: [
      'Земельный участок 5 га в аренде на 49 лет с 2017 года',
      'Земельный участок сельскохозяйственного назначения 365 га на берегу Каспийского моря',
      'Административный корпус 168,2 м², зарегистрирован в ЕГРН в 2019 году',
      'Производственный корпус 5 000 м²',
      'Собственные скважины — 2 шт. по 550 м',
      'Газ, электроэнергия 400 кВт, резервные дизель-генераторы 150 и 400 кВт',
      '6 шестиметровых бассейнов по 18 м³',
      '3 чиллера для охлаждения воды с блоками управления',
      '4 механических фильтра и 4 инъекционных бассейна',
      'Рыбопосадочный материал — 23 551 шт., в том числе 9 592 шт. маточное стадо',
      'Общий объём — 61 595 кг',
    ],
    faq: [
      {
        q: 'Что такое УЗВ-комплекс в Дагестане?',
        a: 'Это производственная площадка СК-АКВА с технологиями замкнутого водоснабжения, бассейнами, фильтрацией и контролируемой средой для выращивания осетровых пород.',
      },
      {
        q: 'Какая продукция связана с производством в Дагестане?',
        a: 'Площадка поддерживает выращивание осетровых пород и поставки черной икры, живой рыбы, мяса осетра и переработанной продукции.',
      },
      {
        q: 'Почему покупателям важна производственная площадка в Дагестане?',
        a: 'Для опта, ресторанов и HoReCa это подтверждает происхождение партии, контроль выращивания и возможность заранее согласовать документы.',
      },
    ],
  },
  {
    id: 'astrakhan',
    slug: 'astrakhan',
    href: '/production/astrakhan',
    title: 'Садковая линия в Астраханской области',
    shortTitle: 'Астраханская область',
    loc: 'Володарский район',
    region: 'Астраханская область',
    locality: 'с. Новинка',
    type: 'Садковая линия',
    image: astrakhanImg,
    imageAlt: 'Садковая линия СК-АКВА в Астраханской области',
    intro:
      'Садковая линия в Астраханской области используется для содержания осетровых пород на реке и поддерживает коммерческие поставки живой и переработанной продукции.',
    points: [
      'Садковая линия на реке',
      'Единовременное содержание до 150 тонн',
      '133 садка по 25 м² и 21 садок по 72 м²',
      'Мальковый цех и переработка',
      'Холодильник мощностью 20 тонн',
    ],
    details: [
      '133 садка по 25 м² и 21 садок по 72 м² установлены на понтонных линиях и соединены мостками',
      'Общая площадь земельного участка — 8,5 га в долгосрочной аренде',
      'Рыбоводный участок по берегу реки — 1,5 км, аренда на 25 лет',
      'Водопользование осуществляется по договору с Волго-Каспийским территориальным управлением Федерального агентства по рыболовству',
      'Возможна реализация живой рыбы и переработанной продукции по индивидуальному запросу',
    ],
    faq: [
      {
        q: 'Что производит садковая линия в Астраханской области?',
        a: 'Садковая линия используется для содержания осетровых пород и поддерживает поставки живой рыбы, переработанной продукции и осетрового направления СК-АКВА.',
      },
      {
        q: 'Можно ли заказать живую осетровую рыбу из Астраханского региона?',
        a: 'Да, живая осетровая рыба доступна по индивидуальному запросу. Навеска, объем, документы и логистика согласуются перед отгрузкой.',
      },
      {
        q: 'Чем важна Астраханская область для доверия к продукции?',
        a: 'Астраханская область является сильным осетровым регионом, а наличие площадки СК-АКВА помогает подтвердить производственную географию и происхождение партии.',
      },
    ],
  },
]

export function getProductionSite(slug) {
  return PRODUCTION_SITES.find((site) => site.slug === slug)
}

export function productionPlaceJsonLd(site) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Place',
    name: site.title,
    url: absoluteUrl(site.href),
    description: site.intro,
    image: absoluteUrl('/og-image.webp'),
    address: {
      '@type': 'PostalAddress',
      addressRegion: site.region,
      addressLocality: site.locality,
      addressCountry: 'RU',
    },
  }
}
